module.exports = __webpack_public_path__ + "img/01.dd0b3bd.png";